module.exports = __webpack_public_path__ + "img/162.b9ea336c.png";